import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import Header from "@/components/main/Header";
import Banner from "@/components/learn/Banner";
import Items from "@/components/learn/Items";
import TileBanner from "@/components/learn/TileBanner";
import OtherModels from "@/components/products/detail/OtherModels";
import ContactUs from "@/components/contact-us";
import Footer from "@/components/main/Footer";
import { TApplicationData } from "@/typings/Props";

export default function Home() {
  const { t } = useTranslation();
  const router = useRouter();
  const items: TApplicationData[] = [
    {
      id: 1,
      title: t("menu.learn.medical.item.title-1"),
      desc: t("menu.learn.medical.item.desc-1"),
      iconPath: "/learn/application/batriatic-icon.svg",
      href: "/learn/medical/batriatic",
    },
    {
      id: 2,
      title: t("menu.learn.medical.item.title-2"),
      desc: t("menu.learn.medical.item.desc-2"),
      iconPath: "/learn/application/Cardiology.svg",
      href: "/learn/medical/cardiology",
    },
    {
      id: 3,
      title: t("menu.learn.medical.item.title-3"),
      desc: t("menu.learn.medical.item.desc-3"),
      iconPath: "/learn/application/diabetes-icon.svg",
      href: "/learn/medical/diabetes",
    },
    {
      id: 4,
      title: t("menu.learn.medical.item.title-4"),
      desc: t("menu.learn.medical.item.desc-4"),
      iconPath: "/learn/application/dietitian-icon.svg",
      href: "/learn/medical/dietetic",
    },
    {
      id: 5,
      title: t("menu.learn.medical.item.title-5"),
      desc: t("menu.learn.medical.item.desc-5"),
      iconPath: "/learn/application/geriatircs.svg",
      href: "/learn/medical/geriatrics",
    },
    {
      id: 6,
      title: t("menu.learn.medical.item.title-6"),
      desc: t("menu.learn.medical.item.desc-6"),
      iconPath: "/learn/application/health-screening-icon.svg",
      href: "/learn/medical/health-screening",
    },
    {
      id: 7,
      title: t("menu.learn.medical.item.title-7"),
      desc: t("menu.learn.medical.item.desc-7"),
      iconPath: "/learn/application/icu-icon.svg",
      href: "/learn/medical/icu",
    },
    {
      id: 8,
      title: t("menu.learn.medical.item.title-8"),
      desc: t("menu.learn.medical.item.desc-8"),
      iconPath: "/learn/application/Pediatrics.png",
      href: "/learn/medical/pediatrics",
    },
    {
      id: 9,
      title: t("menu.learn.medical.item.title-9"),
      desc: t("menu.learn.medical.item.desc-9"),
      iconPath: "/learn/application/physio-rehabilitation-icon.svg",
      href: "/learn/medical/physio-rehabilitation",
    },
    {
      id: 10,
      title: t("menu.learn.medical.item.title-10"),
      desc: t("menu.learn.medical.item.desc-10"),
      iconPath: "/learn/application/nephrology-icon.svg",
      href: "/learn/medical/nephrology",
    },
    {
      id: 11,
      title: t("menu.learn.medical.item.title-11"),
      desc: t("menu.learn.medical.item.desc-11"),
      iconPath: "/learn/application/nutrition-icon.svg",
      href: "/learn/medical/nutrition",
    },
    {
      id: 12,
      title: t("menu.learn.medical.item.title-12"),
      desc: t("menu.learn.medical.item.desc-12"),
      iconPath: "/learn/application/oncology-icon.svg",
      href: "/learn/medical/oncology",
    },
    {
      id: 13,
      title: t("menu.learn.medical.item.title-13"),
      desc: t("menu.learn.medical.item.desc-13"),
      iconPath: "/learn/application/sports-medicine-icon.svg",
      href: "/learn/medical/sports-medicine",
    },
  ];
  return (
    <>
      <Header />
      <Banner
        Bg="/learn/banner/Rectangle-86.png"
        Headline={t("menu.learn.banner.headline")}
        Title={t("menu.learn.medical.banner.title")}
        Desc={t("menu.learn.medical.banner.desc")}
      />
      <Items title={t("menu.learn.medical.item.main-title")} items={items} />
      <TileBanner
        backgroundImg={"/learn/application/medical/image-136.webp"}
        caption={t("menu.learn.medical.studies.caption")}
        title={t("menu.learn.medical.studies.title")}
        desc={t("menu.learn.medical.studies.desc")}
        btn={{
          text: t("menu.learn.medical.studies.btn"),
          onClick: () => {
            router.push("/learn/inbody-in-studies");
          },
        }}
      />
      <TileBanner
        backgroundImg={"/learn/application/medical/Mask-group-3.png"}
        backgroundColor="#971b2f"
        title={t("menu.learn.medical.result-sheet.title")}
        desc={t("menu.learn.medical.result-sheet.desc")}
        btn={{
          text: t("menu.learn.medical.result-sheet.btn"),
          onClick: () => {
            router.push("/learn/body-composition-result-sheet");
          },
        }}
        negative
      />
      <OtherModels />
      <div style={{ margin: "50px 0 0 0" }} />
      <ContactUs />
      <Footer />
    </>
  );
}
